import React, { useState } from 'react';
import './Login.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import siteLogo from '../../assets/ExamWarriorLogo.svg';
import loginImage from '../../assets/Ninja-pana.svg';

const Login = () => {
  const [formData, setFormData] = useState({
    usernameOrEmail: '',
    password: '',
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMessage('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
        email_or_username: formData.usernameOrEmail,
        password: formData.password,
      });

      const { access, refresh, user } = response.data;
      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);
      localStorage.setItem('user', JSON.stringify(user));
      console.log(user);

      setSuccessMessage('Login Successful! Welcome, ' + user.username);

      // ✅ UPDATED: Navigate based on user role
      let redirectPath = '/new-student-dashboard'; // default

      if (user.role === 'admin') {
        redirectPath = '/admin-dashboard';
      } else if (user.role === 'teacher') {
        redirectPath = '/teacher/dashboard'; // Make sure this route exists
      }
      // student goes to default path

      navigate(redirectPath);
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <img src={loginImage} alt="Login Visual" className="login-image" />
      </div>
      <div className="login-right">
        <div className="login-card">
          <img src={siteLogo} alt="Site Logo" className="site-logo" />
          <h2 className="login-form-heading">Log in to your account</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="usernameOrEmail">Username</label>
              <input
                type="text"
                name="usernameOrEmail"
                placeholder="Enter username "
                className="input-field"
                value={formData.usernameOrEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                placeholder="Password"
                className="input-field"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Logging in...
                </>
              ) : (
                'Log In'
              )}
            </button>
          </form>

          {error && <p className="error-message">{error}</p>}
          {successMessage && <p className="success-message">{successMessage}</p>}

          <p className="signup-link">
            Don't have an account? <a href="/signup">Sign up</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;